import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { CvSectionNodeView } from "@/components/editor/nodeviews/CvSectionNodeView";

/**
 * Named CV section header (Experience / Education / Skills / …).
 * Renders as a bold large-font line with a top margin — distinct
 * from a regular \section so it visually slots between cvEntries.
 */
export const CvSectionBlock = Node.create({
  name: "cvSectionBlock",
  group: "block",
  atom: true,

  addAttributes() {
    return {
      blockId: { default: null },
      title: { default: "" },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="cv-section-block"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes, { "data-type": "cv-section-block" })];
  },

  addNodeView() {
    return ReactNodeViewRenderer(CvSectionNodeView);
  },
});
